import { ContentHeader, MainContentArea } from "melco-ui";
import { useTranslation } from "react-i18next";
import { DigitizingOrdersLogsWorkspace } from "../../components/digitizingorderslogs/DigitizingOrdersLogsWorkspace";

export const DigitizingOrdersLogs: React.FC = () => {
  const { t } = useTranslation();


  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.digitizing_orders_logs")}

        />
      }
    >
      <DigitizingOrdersLogsWorkspace />

    </MainContentArea >
  );
};
